import { TableV2 as Table } from "@asayinc/component-library";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ROW_OPTIONS } from "src/constants/options/rowOptions";
import { useTablePagination } from "src/hooks/useTablePagination";
import { useBankruptcyEventsQuery } from "src/store/bankruptcyEvent";
import { getColumnData, getColumns, getRowData } from "./utils";
import { IBankruptcyEvent } from "src/store/bankruptcyEvent/types";
import { ScrollContainer } from "src/components/containers/ScrollContainer";

export function IssuerBankruptcyEvents() {
  const { id: issuerId } = useParams() as { id: string };
  const navigate = useNavigate();

  const {
    getSort,
    offset,
    limit,
    ordering,
    onChangePage,
    onChangeRows,
    onOrderingChange,
  } = useTablePagination();

  const { data, isFetching, isLoading } = useBankruptcyEventsQuery({
    offset,
    limit,
    ordering,
    issuerId,
  });

  const paginateProps = {
    onChangePage,
    onChangeRows,
    rowOptions: ROW_OPTIONS,
    count: data?.count || 0,
    page: Math.floor(offset / limit) + 1,
    rowsPerPage: limit,
  };

  const handleRowClick = (event: IBankruptcyEvent) => {
    const { id } = event;
    navigate(`/bankruptcy-events/${id}/details`);
  };

  const columns = useMemo(() => getColumns(), []);
  const columnData = useMemo(() => {
    return getColumnData({
      getSort,
      onOrderingChange,
    });
  }, [getSort, onOrderingChange]);
  const rowData = getRowData(data?.results || [], handleRowClick);

  return (
    <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
      <Table
        count={data?.count || 0}
        columnData={columnData}
        columns={columns}
        isFetching={isFetching}
        isLoading={isLoading}
        noResultsData={{
          title: "No Bankruptcy Events found for this issuer",
          subtitle: "Sorry, there are no Bankruptcy Events for this issuer.",
        }}
        paginateProps={paginateProps}
        rows={rowData}
        tableMinWidth={900}
        title="Bankruptcy Events"
        titleVariant="subtitle2"
        toolbarInside
      />
    </ScrollContainer>
  );
}
